/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCardReaderAlert = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M21 2H3v6H1v9h2v5h16v-2H5V4h14v7h2zM7 14h2v-2H7zm4 0h2v-2h-2zm-4 4h2v-2H7zm4 0h2v-2h-2zm6-12H7v4h10zm0 8h-2v-2h2zm-2 4h2v-2h-2zm8 2v-7h-2v7zm-2 3h2v-2h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCardReaderAlert as CardReaderAlert };
